// extracted by mini-css-extract-plugin
export default {"tabPanel":"tabbedFormField_tabPanel__FrpWc"};